import Page from "webPage/Page";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import FileUploader from "files/FileUploader"
import CanvasImage from "CanvasImage";
import { handleContactForm } from "./Contact.js";

Page.register('/about-us', () => {
    let uploader = new FileUploader($(".js-cv-uploader"), null, null, {
        allowMultiple: false,
        extensions: ['pdf', 'doc', 'docx']
    });

    uploader.on("fileAdded", ({file}) => {
        $(".form__file-name").text(file.name);
        $(".js-vacancy-enquire-modal").find("[name=file]").val('');
        $(".js-cv-uploader").addClass("form__input--loading");
        $(".form__file-btn").text("Choose");
    }).on("fileUploaded", (file) => {
        $(".js-vacancy-enquire-modal").find("[name=file]").val(file.id).change();
        $(".js-cv-uploader").removeClass("form__input--loading");
        $(".form__file-btn").text("Change");
    }).on("fileError", ({message, file}) => {
        let $file = $(".js-cv-uploader").removeClass("form__input--loading");
        let validator = $file.find("input[name=file]").data("Validator");
        validator.showMessage(message, 'invalid');
        validator.emit("invalid");

        $(".form__file-name").text('Choose a file');
        $(".js-vacancy-enquire-modal").find("[name=file]").val('');
        $(".form__file-btn").text("Choose");
    });

    $("body").on("click", ".js-vacancy-enquire", function () {
        $("body").addClass("modal-active");
        let $course = $(this).parents('.job');
        let title = $course.find("h4").text();
        let id = $course.attr("data-id");

        $(".js-vacancy-enquire-modal").addClass("modal--active")
            .find(".modal__header h4").text(title).end()
            .find("[name=job]").val(id).end()
            .find(".modal__form-text, .form").show().end()
            .find(".form__success").hide();
        return false;
    }).on("click", ".js-send-cv", function () {
        $("body").addClass("modal-active");

        $(".js-vacancy-enquire-modal").addClass("modal--active")
            .find(".modal__header h4").text('Send us your CV').end()
            .find("[name=job]").val('').end()
            .find(".modal__form-text, .form").show().end()
            .find(".form__success").hide();
        return false;
    });

    FormValidator.attach($(".js-vacancy-enquire-form"), {
        inputs: {
            file: {messages: {empty: 'You need to upload your CV'}}
        },
        inputOptions: {
            operator: "your"
        },
    }).on("input:invalid", ({input}) => {
        input.$input.parents(".form__row").first().addClass("form__row--error");
    }).on("input:valid", ({input}) => {
        input.$input.parents(".form__row").first().removeClass("form__row--error");
    }).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".btn--loading")) return;
        $btn.addClass("btn--loading");
        let data = $form.serializeJSON();
        Ajax.post("equip", "apply", data, Ajax.WEBSITE).then(() => {
            $btn.removeClass("btn--loading");

            $(".js-vacancy-enquire-modal").find(".modal__form-text, .form").hide();
            if (data.job !== "") {
                $(".js-vacancy-enquire-modal").find(".form__success[data-type='job']").show();
            } else {
                $(".js-vacancy-enquire-modal").find(".form__success[data-type='cv']").show();
            }

        }).catch((e) => {
            $btn.removeClass("btn--loading");
            if (e.data && e.data.exception === 'HttpValidationException') {
                $form.data("Validator").handleValidationException(e);
            } else {
                alert(e.message);
            }
            console.log(e);
        });
    });

    handleContactForm();

    let masksContent = {
        0: [
            {
                'url': '/images/png/masks/discrimination/content__image-discrimination--mobile-mask.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/about/content__image--mask-600.png',
                'vPos': 'top'
            }
        ],
        760: [
            {
                'url': '/images/png/masks/discrimination/content__image-discrimination--tablet-mask.png',
                'vPos': 'top'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/discrimination/content__image-discrimination--desktop-mask.png',
                'vPos': 'top'
            }
        ]
    };

    let masksPartners = {
        0: [
            {
                'url': '/images/png/masks/about/partners-background-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/about/partners-background-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/about/partners-background-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/about/partners-background-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/about/partners-background-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/about/partners-background-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/about/partners-background-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/about/partners-background-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ]
    };

    new CanvasImage($('.content__img'), masksContent);
    new CanvasImage($('.partners__bg'), masksPartners);
});
